// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dimension__box {
  margin-left: 1rem;
}

.dimension__row {
  display: flex;
  align-items: center;
}

.dimension__row__wrapper {
  padding-right: 6rem;
}

.dimension__wrapper {
  display: flex;
}

.dimension__wrapper__box {
  margin: 0 1rem 1rem 5rem;
  margin-top: 1rem;
}

.dimension__wrapper__box:first-child {
  margin: 0;
  margin-top: 4.5rem;
}

.__wrapper__box {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 1.5rem;
}

.dimension__wrapper__title {
  font-size: var(--caption);
}

.dimension__wrapper__toggle:first-child {
  margin: 0.5rem 0 0 0;
}

.dimension__wrapper__toggle {
  display: flex;
  width: 100%;
  margin: 5rem 0 0 0;
  align-items: center;
}

.dimension__wrapper__toggle:last-child {
  margin: 5rem 0 0 0;
}

.dimension__wrapper__autocomplete__title {
  font-size: var(--caption);
  margin: 2rem 0 0.5rem 0;
}

.dropdown__dimension {
  width: 300px;
}

.disabledDimension {
  background: rgb(238, 237, 237);
}

.dropdown__dimension div div div {
  top: 10px !important
}

.dropdown__dimension div div input {
  padding: 0 0 0 10px!important;
  height: 35px !important;
}

.dropdown__dimension div div{
  padding: 5px !important;
}

.text__field__dimension {
  border-radius: 5px;
  width: 300px;
  color: rgb(199 198 197);
}

.text__field__dimension div input {
  padding: 14px;
  font-size: var(--caption);
}

.text__field__dimension div::before {
  border-bottom-style: none !important;
  border-bottom: none !important
}

.dimension__wrapper__performance {
  margin: 0 1rem 1rem 1rem;
}

.create__wrapper_btn_performance {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 8vh;
}

.switch-with-side-text {
  display: inline;
  font-size: 1.4rem;
}

.tagging__row__container.performance {
  display: inline-grid;
}`, "",{"version":3,"sources":["webpack://./src/components/Modules/RulesConfiguration/components/createTab/Dimension/DimensionRC.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".dimension__box {\n  margin-left: 1rem;\n}\n\n.dimension__row {\n  display: flex;\n  align-items: center;\n}\n\n.dimension__row__wrapper {\n  padding-right: 6rem;\n}\n\n.dimension__wrapper {\n  display: flex;\n}\n\n.dimension__wrapper__box {\n  margin: 0 1rem 1rem 5rem;\n  margin-top: 1rem;\n}\n\n.dimension__wrapper__box:first-child {\n  margin: 0;\n  margin-top: 4.5rem;\n}\n\n.__wrapper__box {\n  display: flex;\n  align-items: center;\n  height: 40px;\n  margin-bottom: 1.5rem;\n}\n\n.dimension__wrapper__title {\n  font-size: var(--caption);\n}\n\n.dimension__wrapper__toggle:first-child {\n  margin: 0.5rem 0 0 0;\n}\n\n.dimension__wrapper__toggle {\n  display: flex;\n  width: 100%;\n  margin: 5rem 0 0 0;\n  align-items: center;\n}\n\n.dimension__wrapper__toggle:last-child {\n  margin: 5rem 0 0 0;\n}\n\n.dimension__wrapper__autocomplete__title {\n  font-size: var(--caption);\n  margin: 2rem 0 0.5rem 0;\n}\n\n.dropdown__dimension {\n  width: 300px;\n}\n\n.disabledDimension {\n  background: rgb(238, 237, 237);\n}\n\n.dropdown__dimension div div div {\n  top: 10px !important\n}\n\n.dropdown__dimension div div input {\n  padding: 0 0 0 10px!important;\n  height: 35px !important;\n}\n\n.dropdown__dimension div div{\n  padding: 5px !important;\n}\n\n.text__field__dimension {\n  border-radius: 5px;\n  width: 300px;\n  color: rgb(199 198 197);\n}\n\n.text__field__dimension div input {\n  padding: 14px;\n  font-size: var(--caption);\n}\n\n.text__field__dimension div::before {\n  border-bottom-style: none !important;\n  border-bottom: none !important\n}\n\n.dimension__wrapper__performance {\n  margin: 0 1rem 1rem 1rem;\n}\n\n.create__wrapper_btn_performance {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 8vh;\n}\n\n.switch-with-side-text {\n  display: inline;\n  font-size: 1.4rem;\n}\n\n.tagging__row__container.performance {\n  display: inline-grid;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
